import UserNoteWithFolder from "~/ui/user-note/folder-btn";
import Content from "./content";
import { IMapyBoxItem } from "~/interfaces";
import { createMyMapsSharing } from "~/ui/mymaps/sharing";
import { createUserNote } from "~/ui/user-note/note";
import { addListener, removeListener } from "~/lib/signals";
import { getNoteVersion, isNoteEnabled, isPremiumNoteUser } from "~/util/user-note";

export default class MymapsPlace extends Content {
	_userNoteWithFolder: UserNoteWithFolder;

	_userNote: ReturnType<typeof createUserNote>;

	_printList: string;

	constructor(data, options) {
		super(data, options);

		this._myBuild();
	}

	_myBuild() {
		this._dom.container.classList.add("content-mymaps-place");

		const data: IMapyBoxItem = "data" in this._data ? this._data.data : this._data;

		this._printList = addListener(this, "print-page", "_printPage");

		if (data) {
			if (data.foreign) {
				this._dom.container.append(createMyMapsSharing({
					author: data.owner_name,
				}));

				if (data.description) {
					this._userNote = createUserNote({
						data,
						foreign: true,
					});

					this._dom.container.append(this._userNote.container);
				}
			} else {
				const userNoteWithFolder = new UserNoteWithFolder({
					enableNote: isNoteEnabled(),
					isPremiumUser: isPremiumNoteUser(),
					noteVersion: getNoteVersion(),
					data,
					folder: {
						id: data.parent_id,
						title: data.parent_name,
					},
				});

				this._userNoteWithFolder = userNoteWithFolder;
				this._dom.container.append(userNoteWithFolder.container);
			}
		}
	}

	_printPage() {
		this._userNote?.print();
		this._userNoteWithFolder?.print();
	}

	destroy(): void {
		if (this._userNoteWithFolder) {
			this._userNoteWithFolder.destroy();
		}

		if (this._userNote) {
			this._userNote.destroy();
		}

		removeListener(this._printList);
	}
}
